type FormStep = {
    id?: string;
    order?: number | string;
    lineOrder?: number | string;
};

const getOrderValue = (value: number | string | undefined) => {
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? 0 : numericValue;
};

export const getEffectiveMultiStepForm = (multiStepForm: FormStep[] = []) =>
    [...multiStepForm].sort((a: FormStep, b: FormStep) => {
        const orderDiff = getOrderValue(a.order) - getOrderValue(b.order);
        if (orderDiff !== 0) {
            return orderDiff;
        }

        return getOrderValue(a.lineOrder) - getOrderValue(b.lineOrder);
    });

export const getEffectiveStepFromPage = (
    multiStepForm: FormStep[] = [],
    currentPage: number = 0
) => {
    const effectiveSteps = getEffectiveMultiStepForm(multiStepForm);
    if (effectiveSteps.length === 0) {
        return undefined;
    }

    const currentPageIndex = currentPage > 0 ? currentPage - 1 : 0;
    return effectiveSteps[currentPageIndex] || effectiveSteps[0];
};

export const filterMetaDataFromPage = (
    isMultiStepForm: boolean,
    camposMetadados: any[] = [],
    multiStepForm: FormStep[] = [],
    formGroups: any[] = [],
    currentPage: number = 0
) => {
    if (!isMultiStepForm) {
        return camposMetadados;
    }

    const currentStep = getEffectiveStepFromPage(multiStepForm, currentPage);

    if (!currentStep?.id) {
        return camposMetadados;
    }

    const formGroupsPageIds = formGroups
        .filter((formGroup: any) => formGroup.stepId === currentStep.id)
        .map((formGroup: any) => formGroup.id);

    return camposMetadados.filter((metadata: any) =>
        formGroupsPageIds.includes(metadata.formGroupId)
    );
};
